import { RollingControlFunction } from '../apollo/graphqlSchema';
import { IconName } from '../../components/Icon';

interface IMeasureRollingControlLookupValue {
  label: string;
  icon: IconName;
  sign: string;
}

const averageSign = 'x̄';
const sumSign = 'Σ';
const windowSign = 'R';

export const measureRollingControlLookup: Record<
  RollingControlFunction,
  IMeasureRollingControlLookupValue
> = {
  [RollingControlFunction.Avg]: {
    label: `${averageSign} Rolling Average`,
    icon: 'rolling-control-average',
    sign: averageSign,
  },
  [RollingControlFunction.Sum]: {
    label: `${sumSign} Rolling Sum`,
    icon: 'rolling-control-sum',
    sign: sumSign,
  },
  [RollingControlFunction.Window]: {
    label: `${windowSign} Rolling Window`,
    icon: 'rolling-control-window',
    sign: windowSign,
  },
};

export const rollingControlLabelLookup: Record<RollingControlFunction, string> =
  {
    [RollingControlFunction.Avg]: 'Rolling Average',
    [RollingControlFunction.Sum]: 'Rolling Sum',
    [RollingControlFunction.Window]: 'Rolling Window',
  };
